import {Component, Injectable,Input,Output,EventEmitter} from '@angular/core'
import { Referral }   from '../_models/index';

@Injectable()
export class ShareReferralService {

  constructor() { }

  referral: Referral;
  saveSelectedReferral(referral){
    this.referral = referral; 
  }
  getSelectedReferral()
  {
    return this.referral;
  }

}

  